import clsx from 'clsx';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import ColumnChooser from '../../../../components/ColumnChooser';
import ExcelExportMenu from '../../../../components/ExcelExportMenu';
import { ExcelExportMode } from '../../../../helpers/excelExportRequest';
import { ColumnChooserModel } from '../../../../models/common/ColumnChooserModel';
import { GetDriverListPagingAndFilterRequest } from '../../../../models/request/driver/GetDriverListPagingAndFilterRequest';
import { RootState } from '../../../../redux/store';
import { MenuComponent } from '../../../../_metronic/assets/ts/components';
import TableConstantActions from '../../../../components/TableConstantActions';

interface Props {
    columns: ColumnChooserModel[]
    setColumns: React.Dispatch<React.SetStateAction<ColumnChooserModel[]>>
    getColumns: () => ColumnChooserModel[]
    pageName: string
    pageVersion: string
    excelExport: (mode: ExcelExportMode) => void
    filter: GetDriverListPagingAndFilterRequest
    getData: (_filter?: GetDriverListPagingAndFilterRequest | undefined) => Promise<void>
    setFilter: React.Dispatch<React.SetStateAction<GetDriverListPagingAndFilterRequest>>
    mrzNfcHandler: () => void
    isListening: boolean
    disconnectSocket: () => void
    selectedCount: number
    deleteFunction: () => void
    updateFunction: () => void
    onSearchSubmit: (e: any) => void
}

const DriverListFilters = ({
    columns,
    setColumns,
    getColumns,
    pageName,
    pageVersion,
    excelExport,
    filter,
    getData,
    setFilter,
    mrzNfcHandler,
    isListening,
    disconnectSocket,
    selectedCount,
    deleteFunction,
    updateFunction,
    onSearchSubmit
}: Props) => {
    const navigate = useNavigate();
    const auth = useSelector((state: RootState) => state.auth)

    useEffect(() => {
        setTimeout(() => { MenuComponent.reinitialization() }, 1000)
    }, [])

    return (
        <React.Fragment>
            <TableConstantActions
                deleteFunction={deleteFunction}
                onSearchSubmit={onSearchSubmit}
                pageName={pageName}
                hideSearch={true}
                searchTerm={filter.searchTerm}
                selectedCount={selectedCount}
                setSearchTerm={(e) => setFilter({ ...filter, searchTerm: e })}
                updateFunction={updateFunction}
            />

            <React.Fragment>
                {
                    auth.user.user?.data.roles.find(x => x == "MRZ & NFC İşlemi Yetkisi") && (
                        <React.Fragment>
                            {
                                !isListening ? (
                                    <div className='m-0'>
                                        <a
                                            onClick={mrzNfcHandler}
                                            className={clsx('btn btn-sm btn-flex fw-bold bg-gray-200 btn-color-gray-700 btn-active-color-primary btn-active-light-primary')}
                                        >
                                            <i className='fa fa-wifi fs-6 color-gray-700 me-1' />
                                            MRZ & NFC
                                        </a>
                                    </div>
                                ) : (
                                    <div className='m-0'>
                                        <a
                                            onClick={disconnectSocket}
                                            className={clsx('btn btn-sm btn-flex fw-bold bg-gray-200 btn-white-gray-700 btn-danger')}
                                        >
                                            <i className='fa fa-times fs-6 color-white-700 me-1' />
                                            İptal Et
                                        </a>
                                    </div>
                                )
                            }
                        </React.Fragment>

                    )
                }
            </React.Fragment>

            <ColumnChooser
                columns={columns}
                getColumns={getColumns}
                pageName={pageName}
                pageVersion={pageVersion}
                setColumns={setColumns}
            />

            <ExcelExportMenu
                pageName={pageName}
                selectedCount={selectedCount}
                onExport={excelExport}
            />

            {/* Filtreler paneli kaldırıldı (22.09.2026): Bağlı Olduğu Firma ve Aktif
                kolon başlığının altındaki filtrede var. */}

            <React.Fragment>
                {
                    auth.user.user?.data.authorizedMenus.find(x => x.menuName == pageName)?.canInsert && (
                        <div className='m-0'>
                            <a
                                onClick={() => navigate('/driver/listadd')}
                                className='btn btn-sm fw-bold btn-primary'
                            >
                                Yeni Sürücü Ekle
                            </a>
                        </div>
                    )
                }
            </React.Fragment>
        </React.Fragment>
    )
}

export default DriverListFilters;